import UserReportsContainer from "./UserReportsContainer";

export default UserReportsContainer;
